import { LocaleTypes } from '@i18n';

import { HeaderNavContext } from '../interfaces';

export type NavPredicate = (ctx: HeaderNavContext) => boolean;

export const isAuth: NavPredicate = ctx => ctx.isAuth;

export const isGuest: NavPredicate = ctx => !ctx.isAuth;

export const isEpn: NavPredicate = ctx => ctx.project === 'epn';

export const isGlobalDomain: NavPredicate = ctx => ctx.project === 'epncpa';

export const isRu: NavPredicate = ctx => ctx.locale === LocaleTypes.ru;

export const hasTaxData: NavPredicate = ctx => Boolean(ctx.userProfile?.hasTaxData);

export const isSelfEmployed: NavPredicate = ctx => ctx.taxData?.type === 'SelfEmployed';

export const isSelfEmployedAllowed: NavPredicate = ctx =>
    ctx.taxData?.type === 'SelfEmployed' && ctx.taxData?.status === 'allow';

export const hasManager: NavPredicate = ctx => Boolean(ctx.manager?.name);

export const all = (...predicates: NavPredicate[]): NavPredicate => ctx =>
    predicates.every(predicate => predicate(ctx));

export const any = (...predicates: NavPredicate[]): NavPredicate => ctx =>
    predicates.some(predicate => predicate(ctx));

export const not = (predicate: NavPredicate): NavPredicate => ctx => !predicate(ctx);
